<template>
  <v-container>
    <v-layout >
      <v-card class="max-auto" min>
        <v-card-title>
           <h4>Agregar Extracción</h4>
        </v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex md5>
              <v-select
                v-model="tipoextraccion"
                :items="tipoextracciones"
                item-text="tipo"
                item-value="id"
                label="Tipo Extraccion"
              ></v-select>
            </v-flex>
            <v-flex md4 ml-3>
              <v-text-field label="Cantidad" v-model="cantidad"></v-text-field>
            </v-flex>
            <v-flex pt-3>
              <v-btn  dark  class="print blue darken-4" @click="guardarextraccion">
              Guardar</v-btn>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    created: function () {
      this.$store.dispatch('requesttipoextracciones')
    },
    data () {
      return {
        'cantidad': 0,
        'tipoextraccion': ''
      }
    },
    computed: {
      tipoextracciones: function () {
        return this.$store.getters.gettipoextracciones
      }
    },
    methods: {
      guardarextraccion: function () {
        this.$store.dispatch('guardarextraccion', {tipo: this.tipoextraccion,
          cantidad: this.cantidad})
      }
    }
  }
</script>
<style>
   @media only screen and (min-device-width: 480px){
     .existencia {
       position: fixed;
       top: 13em;
     }
     .existencia{
       position: fixed;
       left: 10em;
       top: 6.1em;
     }
     .listadoproducto li {
       padding: 8px;
     }
   }
</style>



// WEBPACK FOOTER //
// extraccionadd.vue?5189aaa5